export default __webpack_public_path__ + "static/media/right_slightly_flatFoot.1806fd1b.png";